import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { formatCurrency } from '../../utils/formatting';

// Submit was blocked because the PO total and the total going to A+ differ (Tonya, 2026-10-22).
// Nothing reached A+. The CSR goes back to fix the lines, or submits anyway (logged).
export default function TotalMismatchModal({ mismatch, onSubmitAnyway, onClose }) {
  if (!mismatch) return null;
  const basis = mismatch.basis === 'subtotal' ? 'PO subtotal' : 'PO total (less tax)';
  const diff = Number(mismatch.difference) || 0;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
      <div className="bg-slate-800 rounded-xl border border-amber-500/40 max-w-md w-full shadow-xl">
        <div className="px-5 py-4 border-b border-slate-700 flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-white font-semibold">Totals don't match</h3>
            <p className="text-sm text-slate-400 mt-1">
              The order wasn't sent. Check the lines against the PO, or submit anyway if the difference is expected.
            </p>
          </div>
        </div>
        <div className="px-5 py-4 space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-slate-400">{basis}</span>
            <span className="text-white font-mono">{formatCurrency(mismatch.poTotal)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-400">Going to A+</span>
            <span className="text-white font-mono">{formatCurrency(mismatch.aplusTotal)}</span>
          </div>
          <div className="flex justify-between pt-2 border-t border-slate-700">
            <span className="text-slate-300 font-semibold">Difference</span>
            <span className={`font-mono font-semibold ${diff > 0 ? 'text-amber-400' : 'text-red-400'}`}>
              {diff > 0 ? '+' : ''}{formatCurrency(diff)}
            </span>
          </div>
        </div>
        <div className="px-5 py-3 border-t border-slate-700 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg bg-slate-700 hover:bg-slate-600 text-white transition-colors"
          >
            Go back and fix
          </button>
          <button
            onClick={onSubmitAnyway}
            className="px-4 py-2 text-sm rounded-lg bg-amber-600 hover:bg-amber-500 text-white transition-colors"
          >
            Submit anyway
          </button>
        </div>
      </div>
    </div>
  );
}
